// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: KsLZ7sb8Ji8
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import { useScreenVariants as useScreenVariantsnoO6HAIuEe } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: NoO6H-AIuEE/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicSidebar.module.css"; // plasmic-import: KsLZ7sb8Ji8/css
import _1OverviewsvgLqIs7GMa from "./images/_1Overviewsvg.svg"; // plasmic-import: lqIs7gMA-/picture
import _2Ticketssvg70KlT9L8L from "./images/_2Ticketssvg.svg"; // plasmic-import: 70KlT9L8L/picture
import _6ArticlessvgDzftc2Sdxv from "./images/_6Articlessvg.svg"; // plasmic-import: dzftc2sdxv/picture
import _4ContactssvgU1FHyv6 from "./images/_4Contactssvg.svg"; // plasmic-import: U1F--HYV6/picture
import a1SettingssvgVttMqhZvOo from "./images/a1Settingssvg.svg"; // plasmic-import: VTTMqhZVOo/picture

createPlasmicElementProxy;

export const PlasmicSidebar__VariantProps = new Array();

export const PlasmicSidebar__ArgProps = new Array();

const $$ = {};

function PlasmicSidebar__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsnoO6HAIuEe()
  });
  return (
    <p.Stack
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"dashboardButton"}
        data-plasmic-override={overrides.dashboardButton}
        className={classNames(projectcss.all, sty.dashboardButton)}
      >
        <p.PlasmicImg
          alt={""}
          className={classNames(sty.img___8XYyS)}
          displayHeight={
            hasVariant(globalVariants, "screen", "medium")
              ? "1.04vw"
              : hasVariant(globalVariants, "screen", "large")
              ? "1.04vw"
              : "17px"
          }
          displayMaxHeight={"none"}
          displayMaxWidth={"100%"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={
            hasVariant(globalVariants, "screen", "medium")
              ? "1.04vw"
              : hasVariant(globalVariants, "screen", "large")
              ? "1.04vw"
              : "17px"
          }
          loading={"lazy"}
          src={{
            src: _1OverviewsvgLqIs7GMa,
            fullWidth: 150,
            fullHeight: 150,
            aspectRatio: 1
          }}
        />

        <div
          data-plasmic-name={"title"}
          data-plasmic-override={overrides.title}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.title
          )}
        >
          {"Dashboard"}
        </div>
      </div>
      <div
        data-plasmic-name={"paymentsButton"}
        data-plasmic-override={overrides.paymentsButton}
        className={classNames(projectcss.all, sty.paymentsButton)}
      >
        <p.PlasmicImg
          alt={""}
          className={classNames(sty.img___8Vi8)}
          displayHeight={
            hasVariant(globalVariants, "screen", "medium")
              ? "1.04vw"
              : hasVariant(globalVariants, "screen", "large")
              ? "1.04vw"
              : "17px"
          }
          displayMaxHeight={"none"}
          displayMaxWidth={"100%"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={
            hasVariant(globalVariants, "screen", "medium")
              ? "1.04vw"
              : hasVariant(globalVariants, "screen", "large")
              ? "1.04vw"
              : "17px"
          }
          loading={"lazy"}
          src={{
            src: _2Ticketssvg70KlT9L8L,
            fullWidth: 150,
            fullHeight: 150,
            aspectRatio: 1
          }}
        />

        <div
          data-plasmic-name={"title2"}
          data-plasmic-override={overrides.title2}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.title2
          )}
        >
          {"Payments"}
        </div>
      </div>
      <div
        data-plasmic-name={"contractsButton"}
        data-plasmic-override={overrides.contractsButton}
        className={classNames(projectcss.all, sty.contractsButton)}
      >
        <p.PlasmicImg
          alt={""}
          className={classNames(sty.img__spBda)}
          displayHeight={
            hasVariant(globalVariants, "screen", "medium")
              ? "1.04vw"
              : hasVariant(globalVariants, "screen", "large")
              ? "1.04vw"
              : "17px"
          }
          displayMaxHeight={"none"}
          displayMaxWidth={"100%"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={
            hasVariant(globalVariants, "screen", "medium")
              ? "1.04vw"
              : hasVariant(globalVariants, "screen", "large")
              ? "1.04vw"
              : "17px"
          }
          loading={"lazy"}
          src={{
            src: _6ArticlessvgDzftc2Sdxv,
            fullWidth: 150,
            fullHeight: 150,
            aspectRatio: 1
          }}
        />

        <div
          data-plasmic-name={"title3"}
          data-plasmic-override={overrides.title3}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.title3
          )}
        >
          {hasVariant(globalVariants, "screen", "medium")
            ? "Contracts"
            : "Contracts"}
        </div>
      </div>
      <button
        data-plasmic-name={"clientsButton"}
        data-plasmic-override={overrides.clientsButton}
        className={classNames(
          projectcss.all,
          projectcss.button,
          sty.clientsButton
        )}
        ref={ref => {
          $refs["clientsButton"] = ref;
        }}
      >
        <p.PlasmicImg
          alt={""}
          className={classNames(sty.img___3EJnj)}
          displayHeight={
            hasVariant(globalVariants, "screen", "medium")
              ? "1.04vw"
              : hasVariant(globalVariants, "screen", "large")
              ? "1.04vw"
              : "17px"
          }
          displayMaxHeight={"none"}
          displayMaxWidth={"100%"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={
            hasVariant(globalVariants, "screen", "medium")
              ? "1.04vw"
              : hasVariant(globalVariants, "screen", "large")
              ? "1.04vw"
              : "17px"
          }
          loading={"lazy"}
          src={{
            src: _4ContactssvgU1FHyv6,
            fullWidth: 150,
            fullHeight: 150,
            aspectRatio: 1
          }}
        />

        <div
          data-plasmic-name={"title4"}
          data-plasmic-override={overrides.title4}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.title4
          )}
        >
          {"Clients"}
        </div>
      </button>
      <div
        data-plasmic-name={"settingsButton"}
        data-plasmic-override={overrides.settingsButton}
        className={classNames(projectcss.all, sty.settingsButton)}
      >
        <p.PlasmicImg
          alt={""}
          className={classNames(sty.img___6Cpce)}
          displayHeight={
            hasVariant(globalVariants, "screen", "medium") ? "1.04vw" : "17px"
          }
          displayMaxHeight={"none"}
          displayMaxWidth={"100%"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={
            hasVariant(globalVariants, "screen", "medium") ? "1.04vw" : "17px"
          }
          loading={"lazy"}
          src={{
            src: a1SettingssvgVttMqhZvOo,
            fullWidth: 150,
            fullHeight: 150,
            aspectRatio: 1
          }}
        />

        <div
          data-plasmic-name={"title5"}
          data-plasmic-override={overrides.title5}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.title5
          )}
        >
          {"Settings"}
        </div>
      </div>
    </p.Stack>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "dashboardButton",
    "title",
    "paymentsButton",
    "title2",
    "contractsButton",
    "title3",
    "clientsButton",
    "title4",
    "settingsButton",
    "title5"
  ],

  dashboardButton: ["dashboardButton", "title"],
  title: ["title"],
  paymentsButton: ["paymentsButton", "title2"],
  title2: ["title2"],
  contractsButton: ["contractsButton", "title3"],
  title3: ["title3"],
  clientsButton: ["clientsButton", "title4"],
  title4: ["title4"],
  settingsButton: ["settingsButton", "title5"],
  title5: ["title5"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSidebar__ArgProps,
          internalVariantPropNames: PlasmicSidebar__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSidebar__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSidebar";
  } else {
    func.displayName = `PlasmicSidebar.${nodeName}`;
  }
  return func;
}

export const PlasmicSidebar = Object.assign(
  // Top-level PlasmicSidebar renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    dashboardButton: makeNodeComponent("dashboardButton"),
    title: makeNodeComponent("title"),
    paymentsButton: makeNodeComponent("paymentsButton"),
    title2: makeNodeComponent("title2"),
    contractsButton: makeNodeComponent("contractsButton"),
    title3: makeNodeComponent("title3"),
    clientsButton: makeNodeComponent("clientsButton"),
    title4: makeNodeComponent("title4"),
    settingsButton: makeNodeComponent("settingsButton"),
    title5: makeNodeComponent("title5"),
    // Metadata about props expected for PlasmicSidebar
    internalVariantProps: PlasmicSidebar__VariantProps,
    internalArgProps: PlasmicSidebar__ArgProps
  }
);

export default PlasmicSidebar;
/* prettier-ignore-end */
